import isUndefined from 'lodash/isUndefined'
import { useRouter } from 'labguard-cdk'
import { useUserId } from 'src/hooks'
import useAccountId from './useAccountId'

/**
 * Hook providing 3 boolean props isAccountView, isCreateView, isUpdateView, about the current active view
 */
export default function useCurrentUserView() {
  // get location pathname
  const {
    location: { pathname },
  } = useRouter()

  // get user id
  const userId = useUserId()

  // get account id
  const accountId = useAccountId()

  const isAccountView = pathname === '/account' || accountId === userId
  const isCreateView = !isAccountView && isUndefined(userId)
  const isUpdateView = !isAccountView && !isCreateView

  return { isAccountView, isCreateView, isUpdateView }
}
